import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import { AppConstants } from './core/AppConstants';

Vue.use(VueI18n);

function loadLocaleMessages(): LocaleMessages {
  const locales = window["appSettings"]["locales"];
  //const locales = require.context('./locales', true, /[a-z0-9]+\.json$/i)
  const messages: LocaleMessages = {}
  // locales.keys().forEach(key => {
  //   debugger
  //   const matched = key.match(/([a-z0-9]+)\./i)
  //   if (matched && matched.length > 1) {
  //     const locale = matched[1]
  //     messages[locale] = locales(key)
  //   }
  // })

  Object.keys(locales).forEach(key => {
    messages[key] = window["appSettings"]["locales"][key]
  })

  return messages
}

export default new VueI18n({
  locale: AppConstants.Lang.current,
  fallbackLocale: 'en',
  silentTranslationWarn: false,
  messages: loadLocaleMessages(),
});
